<template lang="pug">
  section.home
    Jumbo(logo="assets/images/logo-ironman-herbalife.png", img="assets/images/img-jumbo.jpg", undertitle="”.", theme="theme-black", extra="", :more="true")
    section.sharer
      Sharer.homesharer(:publicPath="config.publicPath", :slug="config.slug", :title="config.title", :description="config.description", :img="config.img", :hashtag="config.hashtag", :brandtitle="config.brandtitle", :reporttitle="config.reporttitle")

    NewsLooper.block-special(:posts="posts", :postsLoading="postsLoading")
    SponsorsLooper.block-full(:sponsors="sponsors", :sponsorsLoading="sponsorsLoading", video="https://s1.latercera.com/wp-content/uploads/2019/01/loop-sponsor-compressed.mp4")
    VideoLooper.block-special(:videos="videos", :videosLoading="videosLoading")
    TriviaModule.block-full

</template>

<script>
import { mapState } from 'vuex'
import Section from '@/components/Section'
import Jumbo from '@/components/Jumbo'
import Sharer from '@/components/Sharer'
import NewsLooper from '@/components/ironman/NewsLooper'
import SponsorsLooper from '@/components/ironman/SponsorsLooper'
import VideoLooper from '@/components/ironman/VideoLooper'
import TriviaModule from '@/components/ironman/TriviaModule'

export default {
  components: {
    Jumbo,
    Section,
    Sharer,
    NewsLooper,
    SponsorsLooper,
    VideoLooper,
    TriviaModule
  },
  computed: mapState([
    'postsLoading',
    'videosLoading',
    'sponsorsLoading',
    'posts',
    'videos',
    'sponsors',
    'config'
  ]),
  created(){
    this.$store.dispatch('FETCH_POSTS_BY_TAG', {tagid: 33907})
    this.$store.dispatch('FETCH_POSTS_BY_TAG', {tagid: 33958, type: 'video'})
    this.$store.dispatch('FETCH_POSTS_BY_TAG', {tagid: 33969, type: 'sponsor'})
  },
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}
</script>
<style lang="scss">
// @import '~@/components/main';
</style>
<style lang="scss" scoped>
  .sharer{
    padding: 1rem;
  }
  .block{
    max-width: $maxwidth;
    margin: 0 auto;
    padding: 1rem;
  }
  .block-wide{
    max-width: $overwidth;
    margin: 0 auto;
    padding: 1rem;
  }
  .block-special{
    max-width: $uberwidth;
    margin: 0 auto;
    padding: 1rem;
  }
</style>

